module.exports = __webpack_public_path__ + "static/img/clientes_foto1.566f305.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/clientes_foto1.png
// module id = 13
// module chunks = 0